// Cookie banner JavaScript - Simplified version
// The banner now displays by default, no button toggle needed
(function() {
  // Just ensure any existing trigger buttons are hidden
  function hideTriggerButton() {
    const triggerButton = document.getElementById('cookie-consent-trigger');
    if (triggerButton) {
      triggerButton.style.display = 'none';
    }
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideTriggerButton);
  } else {
    hideTriggerButton();
  }

  // Watch for dynamic banner insertion
  const observer = new MutationObserver(function(mutations) {
    hideTriggerButton();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
